module.exports = __webpack_public_path__ + "img/help.a73b86de.svg";